import GenericService from 'od-modules/secure_store/services/GenericService';
import getShoppingCartService from 'od-modules/helpers/get_shopping_cart';
import createShoppingCart from 'od-modules/helpers/create_shopping_cart';
import dynpackShoppingCart from 'components/package_selection_info/dynpack_shopping_cart/api';

class ShoppingCartService extends GenericService {
    getShoppingCart(dispatch) {
        this.service = getShoppingCartService;
        return this.performRequest(null, dispatch);
    }
    createShoppingCart(data, dispatch) {
        this.service = createShoppingCart;
        return this.performRequest(data, dispatch);
    }
    createShoppingCartResidentMeta(data, dispatch) {
        this.service = createShoppingCart;
        createShoppingCart.setMetaUrl();
        return this.performRequest(data, dispatch);
    }
    createDynpackShoppingCart(data, dispatch) {
        const {resident, externalSelectionRequest} = data;
        this.service = createShoppingCart;
        return dynpackShoppingCart.updateShoppingCartProduct(externalSelectionRequest)
            .then(function({dynpackCartProductId}) {
                createShoppingCart.setDPUrl(dynpackCartProductId);
                return this.performRequest(resident, dispatch);
            }.bind(this));
    }
}

export default new ShoppingCartService();
